import { Play, Pause, Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"

type Props = {
  isPlaying: boolean
  isLoading: boolean
  disabled?: boolean
  onClick: (e: React.MouseEvent) => void
  size?: "sm" | "lg"
  className?: string
}

const sizeStyles = {
  sm: {
    button: "w-10 h-10",
    icon: "h-4 w-4",
  },
  lg: {
    button: "w-14 h-14",
    icon: "h-6 w-6",
  },
}

export function PlayButton({
  isPlaying,
  isLoading,
  disabled,
  onClick,
  size = "sm",
  className,
}: Props) {
  const styles = sizeStyles[size]

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onClick(e)
  }

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={cn(
        "shrink-0 rounded-full flex items-center justify-center cursor-pointer",
        "bg-muted hover:bg-muted/80 transition-colors",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        isPlaying && "bg-red-500/20 text-red-500",
        styles.button,
        className
      )}
    >
      {isLoading ? (
        <Loader2 className={cn(styles.icon, "animate-spin")} />
      ) : isPlaying ? (
        <Pause className={styles.icon} />
      ) : (
        <Play className={cn(styles.icon, "ml-0.5")} />
      )}
    </button>
  )
}
